import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const IconButtonDelete = styled(IconButton)`
  padding: 0.3rem;
`;
